import { Link } from "react-router-dom";
import heroImg from "@/assets/hero-building.webp";
import { useLanguage } from "@/hooks/useLanguage";

const HeroSection = () => {
  const { t } = useLanguage();

  return (
    <section className="relative h-screen flex items-center">
      <img
        src={heroImg}
        alt="Moderna ēka ar inženiertehniskām sistēmām"
        className="absolute inset-0 w-full h-full object-cover"
        width={1920}
        height={1280}
        fetchPriority="high"
        decoding="async"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[hsl(var(--brand-navy)/0.85)] via-[hsl(var(--brand-navy)/0.7)] to-[hsl(var(--brand-navy)/0.5)]" />

      <div className="container mx-auto px-4 relative z-10 pt-24">
        <div className="max-w-2xl space-y-6 sm:space-y-8">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-extrabold leading-[1.08] text-white drop-shadow-lg tracking-tight animate-fade-in">
            {t("hero.line1")}
            <br />
            {t("hero.line2")}
            <br />
            <span className="text-blue-300">{t("hero.line3")}</span>
          </h1>
          <p className="text-blue-100 text-base sm:text-lg max-w-lg leading-relaxed animate-fade-in" style={{ animationDelay: "200ms", animationFillMode: "both" }}>
            {t("hero.desc")}
          </p>
          <div className="flex flex-col sm:flex-row flex-wrap gap-3 sm:gap-4 animate-fade-in" style={{ animationDelay: "400ms", animationFillMode: "both" }}>
            <Link
              to="/kontakti"
              className="inline-flex items-center justify-center min-h-[48px] px-6 sm:px-8 py-3 sm:py-3.5 rounded-lg bg-primary text-primary-foreground font-semibold hover:bg-accent hover:scale-105 transition-all duration-300 shadow-lg text-sm sm:text-base"
            >
              {t("hero.cta")}
            </Link>
            <a
              href="#pakalpojumi"
              className="inline-flex items-center justify-center min-h-[48px] px-6 sm:px-8 py-3 sm:py-3.5 rounded-lg border-2 border-white/40 text-white font-semibold hover:bg-white/10 hover:scale-105 transition-all duration-300 text-sm sm:text-base"
            >
              {t("hero.secondary")}
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce hidden sm:block" aria-hidden="true">
        <div className="w-6 h-10 rounded-full border-2 border-white/40 flex items-start justify-center p-1.5">
          <div className="w-1.5 h-3 rounded-full bg-white/60 animate-[fade-in_1.5s_ease-in-out_infinite]" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
